import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Motion";
import { ReviewCard } from "./Reviews";
import { http } from "../../lib/api";

export const DivisionReviews = ({ division }) => {
  const { data } = useQuery({ queryKey: ["reviews", division.key], queryFn: async () => (await http.get("/reviews", { params: { division: division.key } })).data, retry: 1 });
  const all = Array.isArray(data?.items) ? data.items : [];
  const featured = all.filter((r) => r.featured).slice(0, 3);
  if (!featured.length) return null;
  return (
    <section className="border-t hairline" data-testid="division-reviews-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <Reveal>
            <p className="eyebrow">{division.name} · Client Reviews</p>
            <h2 className="font-display text-4xl md:text-5xl text-slate-50 mt-5 leading-[1]">What {division.short.toLowerCase()} clients <em>say.</em></h2>
          </Reveal>
          {all.length > featured.length && (
            <Reveal delay={0.1}><Link to={`/reviews?division=${division.key}`} className="btn-ghost" data-testid="division-reviews-more-link">Read More Reviews <ArrowRight className="w-4 h-4" /></Link></Reveal>
          )}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="division-reviews-grid">
          {featured.map((r, i) => <ReviewCard key={r.id} review={r} i={i} />)}
        </div>
      </div>
    </section>
  );
};
